import {
  Swiper,
  Navigation,
  Pagination,
  Controller,
} from 'swiper';
import type { SwiperOptions } from 'swiper';

Swiper.use([
  Navigation,
  Pagination,
  Controller,
]);

// Custom sliders

const quotesSliderInit = (section:HTMLElement) => {
  const imageSlider:HTMLElement = section.querySelector('.quote-slider-image');
  const contentSlider:HTMLElement = section.querySelector('.quote-slider-content');

  if (imageSlider && contentSlider) {
    const contentOptions: SwiperOptions = {
      loop: true,
      speed: 1000,
      autoHeight: false,
      keyboard: true,
      spaceBetween: 0,
      autoplay: false,
      slideActiveClass: 'slider__slide--active',
      allowTouchMove: false,
      noSwiping: false,

    };

    const subSlider = new Swiper(imageSlider, contentOptions);

    const imageOptions: SwiperOptions = {
      loop: true,
      speed: 1000,
      autoHeight: false,
      keyboard: true,
      spaceBetween: 0,
      autoplay: false,
      slideActiveClass: 'slider__slide--active',
      allowTouchMove: false,
      noSwiping: false,

      pagination: {
        el: contentSlider.querySelector('.slider__pagination') as HTMLElement,
        modifierClass: 'slider__pagination--',
        bulletClass: 'slider__bullet',
        bulletActiveClass: 'slider__bullet--active',
        clickable: true,
        clickableClass: 'slider__pagination--clickable',
      },

      navigation: {
        nextEl: contentSlider.querySelector('.slider__button--next') as HTMLElement,
        prevEl: contentSlider.querySelector('.slider__button--prev') as HTMLElement,
        disabledClass: 'slider__button--disabled',
      },
    };

    const mainSlider = new Swiper(contentSlider, imageOptions);

    mainSlider.controller.control = subSlider;
  }
};

export default quotesSliderInit;
